export default "__VITE_ASSET__8e458420__"